import React from "react";

function SearchSidebarSelections({ selectionItems, onRemoveSelection, onClearAll }) {
  if (selectionItems.length === 0) return null;

  return (
    <div id="flat-category-selections">
      <div className="selections">
        {selectionItems.map((item, index) => (
          <div className="search-selection" key={`${item.label}-${index}`}>
            <span className="term">
              <span className="term-label">{item.label}</span>
              <button
                type="button"
                className="remove selection-remove"
                aria-label={`Remove ${item.label}`}
                onClick={() => onRemoveSelection(index)}
              >
                &times;
              </button>
            </span>
          </div>
        ))}
      </div>
      <div className="clear">
        <a className="deselect-all" href="#" onClick={onClearAll}>
          Clear all search items
        </a>
      </div>
    </div>
  );
}

export default SearchSidebarSelections;
